"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemBlackouts = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var getNextAvailableDay_1 = require("../utils/getNextAvailableDay");
var getItemBlackouts = function (item) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var blackoutDates = (_a = item.blackoutDates) !== null && _a !== void 0 ? _a : (((_b = item.inherited) === null || _b === void 0 ? void 0 : _b.blackoutDates) || []);
    var blackoutDays = (_c = item.blackoutDays) !== null && _c !== void 0 ? _c : (((_d = item.inherited) === null || _d === void 0 ? void 0 : _d.blackoutDays) || []);
    var leadTime = (_e = item.leadTime) !== null && _e !== void 0 ? _e : (_f = item.inherited) === null || _f === void 0 ? void 0 : _f.leadTime;
    var cutoffTime = (_g = item.cutoffTime) !== null && _g !== void 0 ? _g : (_h = item.inherited) === null || _h === void 0 ? void 0 : _h.cutoffTime;
    var dates = blackoutDates.map(function (dateString) {
        return dayjs_1.default(dateString, "YYYY-MM-DD").toDate();
    });
    if (leadTime || cutoffTime) {
        dates.push({
            before: getNextAvailableDay_1.getNextAvailableDay({
                blackoutDates: blackoutDates,
                blackoutDays: blackoutDays,
                leadTime: leadTime,
                cutoffTime: cutoffTime,
            }).toDate(),
        });
    }
    if (blackoutDays.length) {
        dates.push({
            daysOfWeek: blackoutDays,
        });
    }
    return dates;
};
exports.getItemBlackouts = getItemBlackouts;
